import { render, staticRenderFns } from "./WidgetsRow.vue?vue&type=template&id=0b49a8fc&"
import script from "./WidgetsRow.vue?vue&type=script&lang=js&"
export * from "./WidgetsRow.vue?vue&type=script&lang=js&"
import style0 from "./WidgetsRow.vue?vue&type=style&index=0&id=0b49a8fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports